import Contract from "@/model/contract";
import api from "./api";

class CustomerApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async acceptContract(contractId: string, type): Promise<any> {
    const response = await this.getHttp().put<any>("/customers/contracts/" + contractId + "/accept", {
      'is_accept': type
    });
    return response.data;
  }

  async detailContract(id): Promise<Contract> {
    const response = await this.getHttp().get<any>(
      "/customers/contracts/" + id
    );

    if (response.status === 200) {
      return new Contract(response.data.data);
    }
  }

  async confirmContract(id, data): Promise<any> {
    const response = await this.getHttp().put<any>(
      "/customers/contracts/" + id + "/confirm",
      data
    );

    return response.data;
  }

  async confirmContractPast(id): Promise<any> {
    const response = await this.getHttp().put<any>(
      "/customers/contracts/" + id + "/confirm-past"
    );

    return response.data;
  }

  async storeConfirmCheckPointContract(id, data): Promise<any> {
    const response = await this.getHttp().put<any>(
      "/customers/contracts/" + id + "/confirm-check-list",
      data
    );

    return response.data;
  }

  async deleteContractConfirmCheckPoint(id): Promise<any> {
    const response = await this.getHttp().delete<any>(
      "/customers/contracts/confirm-check-list/" + id,
    );

    return response.data;
  }
}
export default new CustomerApi();
